import {useModel} from "./useModel"
import {useMemo} from "react"
import {useQuery} from "@tanstack/react-query"
import {retentionService} from "services"
import {AcademicStageType} from "types/retention"

export const useStaffInfo = () => {
    const model = useModel()
    const user = model?.user
    const campuses = useMemo(() => {
        if (!user?.profiles && !user?.profiles?.length && !user?.profileId) return []

        return user.profiles?.find((profile) => profile.id === user.profileId)?.campuses || []
    }, [user])

    const campusIds = useMemo(() => {
        if (!campuses?.length) return []
        return campuses.map((campus) => campus.id)
    }, [campuses])

    const {
        data: academicStages,
        isLoading,
        isFetching
    } = useQuery(
        ["academic-stages"],
        async () => {
            const data = await retentionService.getAcademicStage()
            const active = data[AcademicStageType.Active] || []
            const probation = data[AcademicStageType.Probation] || []
            const loa = data[AcademicStageType.LOA] || []
            const futureStart = data[AcademicStageType.FutureStart] || []
            return [...active, ...probation, ...loa, ...futureStart]
        },
        {
            enabled: model.isStaff(),
            initialData: []
        }
    )

    return {
        user,
        campusIds,
        campuses,
        academicStages,
        isStaff: model.isStaff(),
        isLoading,
        isFetching
    }
}
